
import { useEffect, useState } from "react";

const MOCK_USER = {
  userDetails: "devuser@local",
  identityProvider: "mock",
  userId: "local-dev",
  userRoles: ["authenticated"],
};

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

function isLocalDev() {
  if (typeof window === "undefined") return false;
  return LOCAL_HOSTNAMES.has(window.location.hostname);
}

export function useAuthUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (
      process.env.REACT_APP_AUTH_DISABLED === "true" &&
      isLocalDev()
    ) {
      setUser(MOCK_USER);
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    let isMounted = true;

    async function loadUser() {
      try {
        const res = await fetch("/.auth/me", { signal: controller.signal });
        if (!res.ok) {
          throw new Error(`Auth request failed: ${res.status}`);
        }
        const data = await res.json();
        if (isMounted) {
          setUser(data && data.clientPrincipal ? data.clientPrincipal : null);
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        if (isMounted) {
          console.warn("Failed to load auth user", err);
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadUser();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return { user, loading };
}
